import { ReactNode } from 'react';

interface Props {
  title: string;
  description: ReactNode;
}
export const ColumnItem = ({ title, description }: Props) => {
  const descriptionClassName = 'text-xs text-gray-500 md:text-sm';
  const isPlainDescription =
    typeof description === 'string' || typeof description === 'number';

  return (
    <>
      <h4 className="mb-1 text-sm font-semibold text-gray-800 md:text-base">
        {title}
      </h4>
      {isPlainDescription ? (
        <p className={descriptionClassName}>{description}</p>
      ) : (
        <div className={descriptionClassName}>{description}</div>
      )}
    </>
  );
};
